export function isRichTextEmpty(value: string | null | undefined): boolean {
	if (!value || typeof value !== "string") return true;
	const trimmed = value.trim();
	if (trimmed === "") return true;
	const stripped = trimmed.replace(/<[^>]*>/g, "").trim();
	return stripped === "";
}